<template>
  <div class="container p-4">
    <p id="emailNotificheHint">L’indirizzo email inserito è utilizzato dal sistema per inviare le notifiche in caso di importanti aggiornamenti relativi alle istanze presentate</p>
    <label for="emailNotifiche" class="active field-required">Email per notifica</label>
    <input ref="inputEmail" id="emailNotifiche" v-model="email" type="email" class="form-control"
           autocomplete="email" required
           :aria-invalid="!!inError['emailNotifiche']"
           :aria-describedby="describedBy"
           @input="clearValidation">
    <p v-if="inError['emailNotifiche']" id="emailNotificheError" class="text-danger small mt-1" role="alert">
      {{ inError["emailNotifiche"] }}
    </p>
    <button @click="save" class="btn btn-success mt-3" data-focus-mouse="false">Conferma</button>
  </div>

</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import * as valUtil from "@/helper/validationUtils";
import { useUserStore } from "@/stores/user";

const props = defineProps<{
  /** Email di notifica già salvata, usata per prepopolare il campo. */
  emailIniziale?: string | null
}>();

const userStore = useUserStore();
const email = ref<string | null>(null);
const inError = ref<{ [key: string]: string }>({} as { [key: string]: string });
const inputEmail = ref<HTMLInputElement | null>(null);

const emit = defineEmits(["close"]);

const describedBy = computed(() =>
  inError.value["emailNotifiche"] ? "emailNotificheHint emailNotificheError" : "emailNotificheHint");

// watch e non onMounted: il contenuto del modale vive dentro <keep-alive>,
// quindi il componente non viene rimontato alle riaperture.
watch(() => props.emailIniziale, (value) => {
  email.value = value ?? null;
  inError.value = {};
}, { immediate: true });

onMounted(() => {
  // Il modale è già nel DOM al mount: il focus va spostato quando diventa visibile.
  inputEmail.value?.closest(".modal")
    ?.addEventListener("shown.bs.modal", () => inputEmail.value?.focus());
});

function clearValidation(e: Event) {
  valUtil.clearValidation(inError, e as InputEvent & { target: { id: string } });
}

function save() {
  if (valUtil.validationEmail(email.value)) {
    userStore.updateUser(email.value ?? null, null, null).then(() => {
      emit("close");
    });
  } else {
    inError.value["emailNotifiche"] = "Inserire una mail valida per le notifiche";
  }
}

</script>

<style scoped>

</style>
